import { Component, OnInit } from '@angular/core';
import { JsLoaderService } from 'src/shared/services/js-loader.service';
import { AppConfig } from 'src/app/app-config';

@Component({
  selector: 'app-immunizations',
  templateUrl: './immunizations.component.html'
})
export class ImmunizationsComponent implements OnInit {

  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }
  immunizationGuide = this.config.ImmuniationUserGuide;
  ngOnInit() {
    this.jsLoader.loadScripts();
  }

}
